<template>
  <div id='mainControlPanel'>
<!--   <el-button @click="drawRoadText" plain>地面文字</el-button>
  <el-button @click="drawRoadLamp" type="primary" plain>路灯</el-button>
  <el-button @click="drawRoadDefect" type="success" plain>病害</el-button>
  <el-button @click="drawRoadArrow" type="info" plain>箭头</el-button>
  <el-button @click="drawRoadIndicator" type="info" plain>标牌</el-button>
  <el-button @click="showNav" type="info" plain>模拟驾驶</el-button> -->
  <el-menu default-active="1" class="el-menu-vertical-demo" mode='vertical'>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span slot="title">设施</span>
        </template>
        <el-submenu index="1-1">
          <span slot="title">病害</span>
          <el-menu-item index="1-1-2" @click='drawRoadDefect' >纵向裂缝</el-menu-item>
          </el-menu-item>
        </el-submenu>
        <el-submenu index="1-2">
          <span slot="title">交安设施</span>
          <el-menu-item index="1-2-1" @click='drawRoadIndicator' >路牌</el-menu-item>
          <el-menu-item index="1-2-2" @click='drawRoadArrow' >地面箭头</el-menu-item>
          <el-menu-item index="1-2-5" @click='drawRoadText' >地面文字</el-menu-item>  
        </el-submenu>
      </el-submenu>
       <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span slot="title">控制</span>
        </template>
        <el-menu-item index="2-1" @click='showNav' >模拟驾驶</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>

</template>
<script>
   import {DefectControlCommand} from './commands/DefectControlCommand.js'
   
export default {
  data: function() {
    return {

    }
  },
  methods: {
    drawRoadLamp : function(){
        var eventArg = {'command': new DefectControlCommand(0, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    drawRoadText : function(){
        var eventArg = {'command': new DefectControlCommand(1, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    drawRoadDefect : function(){
        var eventArg = {'command': new DefectControlCommand(2, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    drawRoadArrow : function(){
        var eventArg = {'command': new DefectControlCommand(3, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    drawRoadIndicator : function(){
        var eventArg = {'command': new DefectControlCommand(4, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    showNav : function(){
        var eventArg = {'command': new DefectControlCommand(5, this)};
        this.$emit("mainControlCommand", eventArg);
    },
    showPermControlPanel : function(){
      this.selectMajorBtn($('#permControlBtn'));
    },
    showRoadLinePanel : function(){
      this.selectMajorBtn($('#roadLineBtn'));
    },
    showDepartmentPanel : function(){
      this.selectMajorBtn($('#departmentBtn'));
    },
    showTrafficPanel : function(){
      this.selectMajorBtn($('#trafficSafetyBtn'));
    },
    showConstruPanel : function(){
      this.selectMajorBtn($('#construBtn'));
    },
    showDefectPanel: function(){
      this.selectMajorBtn($('#defectBtn'));
      $("#defectList").show();
    },
    selectMajorBtn : function(btn){
      $("#mainControlPanel .icoBtn").each(function(inex, item){
        $(item).removeAttr("selected");
      });
      btn.attr("selected", "");
    }
  }
}
</script>
<style lang="less">
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 250px;
  }
  #mainControlPanel{
    position:absolute;
    width:250px;
    height:600px;
    right:0px;
    top:30px;
  }

  #mainControlPanel1{
    position:absolute;
    width:1000px;
    height:100px;
    
    bottom:10% !important;
    left:20%;

    .icoBtn{
      background-size: cover;
      width:93px;
      height:84px;
      border:0px;
      background-color:transparent;
      float:left;
      margin-left:70px;
    }
    .icoBtn:hover{
      margin-top:-3px;
      cursor:pointer;
    }


    #permControlBtn{
      background-image: url(/static/imgs/perm.png);
      
    }
    
    #permControlBtn[selected]{
      background-image: url(/static/imgs/perm_sel.png);
    }

    #roadLineBtn{
      background-image: url(/static/imgs/roadline.png);
    }

    #roadLineBtn[selected]{
      background-image: url(/static/imgs/roadline_sel.png);
    }

    #departmentBtn{
      background-image: url(/static/imgs/department.png);
    }

    #departmentBtn[selected]{
      background-image: url(/static/imgs/department_sel.png);
    }

    #defectBtn{
      background-image: url(/static/imgs/defect.png);
    }

    #defectBtn[selected]{
      background-image: url(/static/imgs/defect_sel.png);
    }

    #trafficSafetyBtn{
      background-image: url(/static/imgs/trafficsafety.png);
    }

    #trafficSafetyBtn[selected]{
      background-image: url(/static/imgs/trafficsafety_sel.png);
    }

    #construBtn{
      background-image: url(/static/imgs/constru.png);
    }

    #construBtn[selected]{
      background-image: url(/static/imgs/constru_sel.png);
    } 

  }

</style>



// WEBPACK FOOTER //
// src/plugins/components/Web3dModels/MainControlPanel.vue